export const three_dots_menu_icon_IMG = "three_dots_menu_icon.svg";
export const minus_button_IMG = "minus_button.svg";
export const arrow_IMG = "arrow.svg";
export const profile_avatar_IMG = "profile_avatar.svg";
export const warehouse_logo_IMG = "warehouse_logo.png";
export const pharmacy_logo_IMG = "pharmacy_logo.png";
export const gray_plus_IMG = "gray_plus.svg";
export const X_IMG = "X.svg";
export const x_gray_IMG = "x_gray.svg";
export const Logo_IMG = "dark-logo.svg";
export const plus_button = "plus_button.svg";
export const pdf_icon = "pdf_icon.svg";
export const img_file_logo_IMG = "img_file_logo.svg";
export const facility_license_IMG = "facility-license.svg";
export const red_x = "red-x.svg";
export const emptyPages_IMG = "emptyPages.png";
export const calendar_date_picker_IMG = "calendar-date-picker.svg";
export const internal_server_error_avatar_IMG = "internal_server_error.svg";
export const add_image_plus_IMG = "add_image_plus.svg";
export const overlay_close_IMG = "overlay_close.svg";
export const chevron_down_IMG = "chevron-down.svg";
export const search_icon_IMG = "search_icon.svg";
export const close_icon_IMG = "close_icon.svg";
export const general_table_filter_IMG = "general_table_filter.svg";
export const gray_x_padding_IMG = "gray_x_padding.svg";
export const red_trash_IMG = "red_trash.svg";
export const chevron_down_table_IMG = "chevron-down-table.svg";
export const chevron_left_table_IMG = "chevron-left-table.svg";
export const left_active_table_arrow_IMG = "left-active-table-arrow.svg";
export const right_table_arrow_IMG = "right-table-arrow.svg";
export const home_IMG = "home.svg";
export const home_active_IMG = "home_active.svg";
export const active_drugs_IMG = "active_drugs.svg";
export const drugs_IMG = "drugs.svg";
export const active_products_IMG = "active_products.svg";
export const products_IMG = "products.svg";
export const cart_trash_IMG = "cart_trash.svg";
export const orders_active_IMG = "orders_active.svg";
export const order_IMG = "order.svg";
export const offers_active_IMG = "offers_active.svg";
export const offers_IMG = "offers.svg";
export const active_staff_IMG = "active_staff.svg";
export const staff_IMG = "staff.svg";
export const active_setting_IMG = "active_setting.svg";
export const settings_IMG = "settings.svg";
export const active_pharmacy_warehouses_IMG = "active_pharmacy_warehouses.svg";
export const warehouse_icon_IMG = "warehouse_icon.svg";
export const facility_gray_IMG = "facility_gray.svg";
export const blue_house_IMG = "blue_house.svg";
export const marker_IMG = "marker.png";
export const blue_marker_IMG = "blue_marker.png";
export const phone_IMG = "phone.svg";
export const blue_phone_IMG = "blue_phone.svg";
export const clock_IMG = "clock.svg";
export const blue_clock_IMG = "blue_clock.svg";
export const company_IMG = "company.svg";
export const blue_companies_IMG = "blue_companies.svg";
export const view_eye_icon_IMG = "view_eye_icon.png";
export const edit_pen_IMG = "edit_pen.svg";
export const ksa_flag_IMG = "ksa_flag.svg";
export const english_flag_IMG = "english_flag.png";
export const bell_ringing_IMG = "bell-ringing.svg";
export const chevron_right_bold_IMG = "chevron-right-bold.svg";
export const arrow_right_IMG = "arrow-right.svg";
export const double_blue_arrows_IMG = "double-blue-arrows.svg";
export const drug_product_IMG = "drug_product.png";
export const warehouse_avatar_IMG = "warehouse_avatar.png";
export const pharmacy_avatar_IMG = "pharmacy_avatar.png";
export const default_avatar_IMG = "default_avatar.png";
export const reject_reason_error_IMG = "reject_reason_error.svg";
export const red_arrow_IMG = "red-arrow.svg";
export const active_cart_IMG = "active_cart.svg";
export const active_notifications = "active_notifications.svg";
export const notifications_IMG = "notifications.svg";
export const end_offer_clock_IMG = "end_offer_clock.svg";
export const delete_sign_IMG = "delete_sign.svg";
export const star_IMG = "star.svg";
export const all_warehouses_star_IMG = "all_order_star.svg";
export const orange_flag_IMG = "orange_flag.svg";
export const percentage_sign_IMG = "percentage_sign.svg";
// export const no_result_avatar_IMG = "no_result_avatar.svg";
export const no_result_avatar_IMG = "no_result.webp";
export const search_avatar_IMG = "search_avatar.svg";
export const product_test_image_IMG = "product_test_image.png";
export const profile_info_house_IMG = "profile_info_house.svg";
export const white_flag_IMG = "white_flag.svg";
export const gray_flag_IMG = "gray_flag.svg";
export const waiting_red_IMG = "waiting_red.svg";
export const waiting_green_IMG = "waiting_green.svg";
export const forbidden_IMG = "forbidden.svg";
export const error404Avatar_IMG = "error404.svg";
export const sms_white_IMG = "sms_white.svg";
export const whatsapp_IMG = "whatsapp.svg";
export const pharmacy_type_active_IMG = "pharmacy-type-active.svg";
export const warehouse_type_active_IMG = "warehouse-type-active.svg";
export const success_toast_rounded_blur_IMG = "success_toast_rounded_blur.svg";
export const error_toast_rounded_blur_IMG = "error_toast_rounded_blur.svg";
export const warehouse_profile_panel_bg_IMG = "warehouse_profile_panel_bg.svg";
export const warehouse_info_link_IMG = "warehouse_info_link.svg";
export const warehouse_info_email_IMG = "warehouse_info_email.svg";
export const warehouse_info_telephone_IMG = "warehouse_info_telephone.svg";
export const warehouse_info_phone_IMG = "warehouse_info_phone.svg";
export const white_plus_IMG = "white-plus.svg";
export const calender_IMG = "calender.svg";
export const no_selected_items_IMG = "no_selected_items.svg";
export const invalid_docs_IMG = "invalid_docs.svg";
export const active_warehouse_IMG = "active_warehouse.svg";
export const x_gray_padding_IMG = "x_gray_padding.svg";
export const timer_48_h_IMG = "timer_48_h.svg";
export const reject_order_IMG = "reject_order.svg";
export const document_timer_IMG = "document_timer.svg";
export const edit_pen_blue_IMG = "edit_pen_blue.svg";
export const add_blue_IMG = "add_blue.svg";
export const cart_IMG = "cart.svg";
export const chevron_down_blue_IMG = "chevron_down_blue.svg";
export const chevron_right_IMG = "chevron-right.svg";
export const success_toast_check_IMG = "success_toast_check.svg";
export const error_toast_icon_IMG = "error_toast_icon.svg";
export const warning_toast_icon_IMG = "warning_toast_icon.svg";
export const eye_IMG = "eye.svg";
export const closedEye_IMG = "closedEye.svg";
export const authBg_IMG = "authBg.svg";
export const loginBg_IMG = "loginLogo.svg";
export const circlesPattern_IMG = "circles-pattern.svg";
export const header_privacy_policy_IMG = "header-privacy-policy.svg";
export const DomeCare_Full_Logo_IMG = "domecare-logo.svg";
export const incoming_order_orange_arrow_IMG =
  "incoming_order_orange_arrow.svg";
export const incoming_order_blue_arrow_IMG = "incoming_order_blue_arrow.svg";
export const outgoing_aqua_arrow_IMG = "outgoing_aqua_arrow.svg";
export const default_Image_For_All_IMG = "Default_Image_For_All.svg";
export const double_top_arrows_IMG = "double_top_arrows.svg";
export const offer_icon_IMG = "offer_icon.svg";
export const offer_icon_primary_IMG = "offer.svg";
export const download_icon_IMG = "download.svg";
export const print_icon_IMG = "print.png";
export const arrow_rotate_left_IMG = "arrow-rotate-left.svg";
export const arrow_refresh_IMG = "arrow-refresh.svg";
export const alert_red_IMG = "alert_red.svg";
export const share_cart_IMG = "share-cart.svg";
export const green_check_2_IMG = "green_check_2.svg";
export const forget_password_IMG = "forget_password.svg";
export const otp_IMG = "otp.svg";
export const pattern_IMG  = "pattern.svg";
export const award_point_IMG  = "award-point.svg";
export const award_success_IMG  = "award-success.svg";
export const empty_logo_IMG  = "Empty.svg";